import { ENTITY_RELATIONSHIP, ValidateYup } from "@tastyworks/tastyworks-api"
import { boolean, object, string } from "yup"

const schema = object({
  relationshipToBusiness: string()
    .required()
    .oneOf(Object.values(ENTITY_RELATIONSHIP)),
  requireTaxWithholding: boolean(),
  businessSubjectToTaxWithholding: boolean()
    .nullable()
    .when("requireTaxWithholding", {
      is: true,
      then: (schema) => schema.required(),
    }),
})

export const businessRelationshipSchema = ValidateYup.buildSchema(
  "BusinessRelationship",
  schema
)

/* v8 ignore start -- @preserve */
if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  const validBusinessRelationship = {
    relationshipToBusiness: ENTITY_RELATIONSHIP.EMPLOYEE,
    requireTaxWithholding: true,
    businessSubjectToTaxWithholding: false,
  }

  describe("businessRelationshipSchema", () => {
    it("successfully validates required relationship info", () => {
      expect(
        businessRelationshipSchema.isValidSync(validBusinessRelationship)
      ).toBe(true)
    })

    it("requires a relationship from the list of options", () => {
      expect(
        businessRelationshipSchema.isValidSync({
          ...validBusinessRelationship,
          relationshipToBusiness: "invalid",
        })
      ).toBe(false)
    })

    it("requires businessSubjectToTaxWithholding when requireTaxWithholding is true", () => {
      expect(
        businessRelationshipSchema.isValidSync({
          ...validBusinessRelationship,
          businessSubjectToTaxWithholding: undefined,
        })
      ).toBe(false)
    })

    it("allows businessSubjectToTaxWithholding to be undefined when requireTaxWithholding is false", () => {
      expect(
        businessRelationshipSchema.isValidSync({
          ...validBusinessRelationship,
          requireTaxWithholding: false,
          businessSubjectToTaxWithholding: undefined,
        })
      ).toBe(true)
    })
  })
}
